import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/poisson-distribution-calculator',
  component: () => import('../../routes/PoissonDistributionCalculator.svelte'),
  card: {
    id: 'poisson-distribution-calculator',
    title: 'Poisson Distribution',
    description:
      'Calculate Poisson probabilities P(X = k), P(X ≤ k), and more. Find the likelihood of events occurring at a given average rate.',
    icon: 'functions',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/poisson-distribution-calculator',
    category: 'Conversion & Math',
  },
  seo: {
    title: 'Poisson Distribution Calculator – Probability of Events at Average Rate',
    description:
      'Free Poisson distribution calculator. Calculate P(X = k), P(X ≤ k), cumulative probabilities, and build a full probability table for any lambda.',
  },
};

export default meta;
